import React from "react";
import AxiosInstance from "../../AxiosInstance";
import { Button } from "antd";
import { alertError } from "./Alerts";
import { useNavigate } from "react-router-dom";

export default function RoleSwitch({ userRoles, role = "" }) {
  const navigate = useNavigate();
  const changeRole = async (role) => {
    const payload = {
      userRole: role,
    };
    AxiosInstance()
      .get("/profile/verified")
      .then((resp) => {
        let payload = resp.data;
        switch (role) {
          case "PARTNER":
            navigate("/partner-registration", {
              state: {
                payload,
              },
            });
            break;
          case "INVESTOR":
            navigate("/investpref", {
              state: {
                payload,
              },
            });
            break;
          case "POLICY_MASTER":
            AxiosInstance()
              .post("/auth/addNewRole", { userRole: "POLICY_MASTER" })
              .then((resp) => {
                localStorage.setItem("token", resp.data.token);
                navigate("/add-policy");
              })
              .catch((err) => {
                alertError(err.response.data.message);
              });
            break;

          default:
            break;
        }
      })
      .catch((err) => {
        alertError(err.response.data.message);
      });
  };
  const currentRole = localStorage.getItem("currentRole");
  return (
    <div className="flex d-flex justify-content-between">
      <div className="pb-5 ">
        {!userRoles.includes("POLICY_MASTER") && (
          <Button
            type="default"
            className="mx-1"
            onClick={() => {
              changeRole("POLICY_MASTER");
            }}
          >
            Register As Policy Holder
          </Button>
        )}
        {!userRoles.includes("INVESTOR") && (
          <Button
            type="default"
            className="mx-1"
            onClick={() => {
              changeRole("INVESTOR");
            }}
          >
            Register As Investor
          </Button>
        )}
        {!userRoles.includes("PARTNER") && (
          <Button
            type="default"
            onClick={() => {
              changeRole("PARTNER");
            }}
          >
            Register As Partner
          </Button>
        )}
      </div>
      {(currentRole === "INVESTOR" || currentRole === "POLICY_MASTER") && (
        <a
          href={
            currentRole === "INVESTOR"
              ? "investor/matured-policies"
              : "policy/matured-policies"
          }
        >
          Matured Policies
        </a>
      )}
    </div>
  );
}
